module.exports = __webpack_public_path__ + "img/ic_32_sport_hockey.65a8781e.svg";